import React from "react"
import "twin.macro"
import { Container } from "./auvelity-ui"
import { ISIIndication, ISISafety } from "../content/isi/patient"
import { ISIIndicationEs, ISISafetyEs } from "../content/isi/patient-spanish"

const ISIStatic = ({ ref, language }) => {
  return (
    <div
      id="isi"
      tw="py-6 pt-12 md:(pt-6 pb-12)"
      ref={ref}
      data-gtm-location="isi"
    >
      <Container>
        {language === "spanish" ? <ISIIndicationEs isStatic /> : <ISIIndication isStatic />}
        {language === "spanish" ? <ISISafetyEs isStatic /> : <ISISafety isStatic />}


      </Container>
    </div>
  )
}

export default ISIStatic
